/* PACKAGES */
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

/* ANIMATION */
import { animation } from "config";

const Banner = () => {
  return (
    <motion.div variants={animation} className="p-0">
      {/* HEADING */}
      <div className="py-6 xl:py-12 lg:py-12">
        <div className="container">
          <div className="w-fit mx-auto bg-logo px-4 py-2 rounded-full border-2 border-white shadow-md">
            <p className="text-sm xl:text-base lg:text-base font-source font-semibold text-white uppercase">
              Connecting Alumni, Strengthening Communities
            </p>
          </div>
          <div className="w-full xl:w-1/2 lg:w-1/2 mx-auto mt-5 xl:mt-10 lg:mt-10">
            <h1 className="text-4xl xl:text-5xl lg:text-5xl font-roundo font-bold text-black text-center leading-tight">
              Build a Vibrant Alumni Network with Ease and Impact
            </h1>
            <h5 className="mt-5 text-lg xl:text-2xl lg:text-2xl font-source font-normal text-greyText text-center">
              Engage, mentor, and grow your alumni community with our all-in-one
              platform designed for universities and graduates.
            </h5>
          </div>
        </div>
      </div>

      {/* IMAGES */}
      <div className="p-0">
        <Marquee>
          <img
            src={require("../../assets/images/yearbook/01.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
          <img
            src={require("../../assets/images/yearbook/02.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
          <img
            src={require("../../assets/images/yearbook/03.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
          <img
            src={require("../../assets/images/yearbook/04.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
          <img
            src={require("../../assets/images/yearbook/05.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
          <img
            src={require("../../assets/images/yearbook/06.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
          <img
            src={require("../../assets/images/yearbook/07.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
          <img
            src={require("../../assets/images/yearbook/08.jpg")}
            className="w-[25vh] xl:w-[45vh] lg:w-[45vh] h-[25vh] xl:h-[45vh] lg:h-[45vh] rounded-xl object-cover object-center mr-5 xl:mr-10 lg:mr-10"
            alt="Alumni Connection Hub"
          />
        </Marquee>
      </div>
    </motion.div>
  );
};

export default Banner;
